module.exports = __webpack_public_path__ + "img/payment-pending.54f3e4a3.svg";